import React from 'react';
import { Paper, Typography } from '@material-ui/core';

import { UnderConstruction } from 'shared';
import { useIsFeatureOn } from 'shared/hooks/featureFlags/useIsFeatureOn';

const CROSS_DOCK_FEES_FEATURE_FLAG = 'CROSS_DOCK_FEES';

function CrossDockPurchaseOrders() {
    const { data: crossDockFeesEnabled, isLoading } = useIsFeatureOn(CROSS_DOCK_FEES_FEATURE_FLAG);

    if (isLoading) {
        return null;
    }

    if (!crossDockFeesEnabled) {
        return <UnderConstruction title="Crossdock Fees" />;
    }

    return (
        <Paper className="p-4">
            <Typography variant="h5" component="h1">
                Crossdock Fees
            </Typography>
        </Paper>
    );
}

export { CrossDockPurchaseOrders };
